import { Component, Input, OnInit, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ProtocolService } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-protocol-publish-dialog',
  templateUrl: './protocol-publish-dialog.component.html',
  styleUrls: ['./protocol-publish-dialog.component.scss'],
})
export class ProtocolPublishDialogComponent implements OnInit {
  @Input() protocolId!: string;

  readonly loading = signal(true);
  readonly audience = signal<string[] | null>(null);

  constructor(private readonly protocolService: ProtocolService) {}

  async ngOnInit(): Promise<void> {
    try {
      const result = await firstValueFrom(this.protocolService.getPublishAudience(this.protocolId));
      this.audience.set(result.tenantNames);
    } catch {
      this.audience.set(null);
    } finally {
      this.loading.set(false);
    }
  }
}
